import React, { createContext, useContext } from 'react';
import { BrandingConfig, DEFAULT_BRANDING, getBrandingConfig } from './brandingConfig';

const BrandingContext = createContext<BrandingConfig>(DEFAULT_BRANDING);

/**
 * Provides the resolved branding configuration (defaults merged with any
 * query-string overrides) to the component tree.
 */
export function BrandingProvider({
  children,
  config,
}: {
  children: React.ReactNode;
  /**
   * Optional pre-resolved config. When omitted, the config is read from the
   * current window location. Primarily useful for tests.
   */
  config?: BrandingConfig;
}) {
  const value = config ?? getBrandingConfig();
  return <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>;
}

/** Returns the current branding configuration. */
export function useBranding(): BrandingConfig {
  return useContext(BrandingContext);
}
